export default __webpack_public_path__ + "static/media/messages.ca0813f4.ico";